module.exports = __webpack_public_path__ + "static/media/supervise-del.c8d3071c.png";